import { css } from 'react-emotion'

const commonStyles = {
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%'
}

const styles = {
  component: css({
    position: 'relative',
    borderRight: '1px solid #e6e6e6',
    borderLeft: '1px solid #e6e6e6'
  }),
  track: css({
    height: '8px'
  }),
  buffer: css({
    ...commonStyles,
    backgroundColor: '#e6e6e6'
  }),
  fill: css({
    ...commonStyles,
    background: '#fbbd08'
  }),
  input: css({
    ...commonStyles,
    width: '100%',
    opacity: 0,
    cursor: 'pointer'
  })
}

export default styles



// WEBPACK FOOTER //
// ./src/Components/VideoPlayer/Seek/SeekStyles.js